import { endpoints } from './endpoints';

export const environment = {
  environment: 'integration',
  production: false,
  displayMobileIdField: true,
  api: {
    baseUrl: 'https://api.incivilite.integration.rivp.fr/',
    endpoints,
  },
  apiRivp: {
    baseUrl: 'https://api.rivp.fr/index.php',
    apiKey: 'RYwIHByo7QEJDELOYE3ibUmZj0HAEO546ZEp6jHoiiYK3SZ0DebfRSEBpRNjlL7HssTCIALPG5CUBJfS06XhfQgLFsw0Wi67jPk4SAO2YTFcusZmefcMc4WbTAGNeGDGcxYJcc3vhnN7KyreqOHusQzH5KEZa2mkfyiaOoPeedg6grd5VKuGhsChRJoSKX163xNa6oYIp1NZagOJeskQKMwMDPHtpfhIMhLhSrGhIiPxGqAvWgCOJhYX2Khf1qnV',
    session_id: 'caaf73735a10dcf66a60dffcd3',
    endpoints: endpoints.api_rivp,
  },
  pictures: {
    addLogoRIVP: true,
  },
};
